import { Chip, ChipProps } from '@mui/material';

export interface ChipCellProps extends Omit<ChipProps, 'label' | 'color'> {
  value: Pick<ChipProps, 'label' | 'color'>;
}

export default function ChipCell({ value, ...props }: ChipCellProps) {
  return <Chip label={value.label} color={value.color} {...props} />;
}
